import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { MembershipAwarenessFormData } from '../types';

import { getMembershipFormData } from './getMembershipFormData';

export async function getMembershipAwarenessFormData(
	utilityContext: UtilityContext,
): Promise<MembershipAwarenessFormData> {
	return getMembershipFormData(utilityContext);
}
